import React, { useState } from "react";
import LoadingBox from "../../modules/shared/components/LoadingBox";
import MessageBox from "../../modules/shared/components/MessageBox";
import ErcModal from "../../modules/shared/components/ErcModal";
import SelectMultiVariant from "../NewProductScreen/SelectMultiVariant";
import SelectQty from "../NewProductScreen/SelectQty";
import AddCartButton from "../NewProductScreen/AddCartButton";
import LoadingBoxWithoutText from "../../modules/shared/components/LoadingBoxWithoutText";
import ShippingMessage from "../AdminShippingMessage/ShippingMessage";
import AdvantagesBoard from "../AdvantagesBoard/AdvantagesBoard";
import PriceOffer from "../../components/PriceOffer/PriceOffer";
import { useCalculateValidPrice } from "../../hooks/useCalculateValidPrice";
import "../../components/PriceOffer/textInBorder.css";
import SummaryBeforeAddToCart from "../../components/PriceOffer/SummaryBeforeAddToCart";
import ProductLandingGalery from "./ProductLandingGalery";
import ScarcityMessage from "../AdminShippingMessage/ScarcityMessage";

export default function OrderCartWithVariants(props) {
  // PROPS ARE COMING FROM ProductLandings
  const {
    loadingSkuData,
    errorSkuData,
    product,
    loadingCampaign,
    errorCampaign,
    productCampaign,
    width,
    skuData,
    clearCartSkuItems,
    isPending,
    qty,
    price,
    cartSkuItems,
    variants,
    setChoosenVariants,
    choosenVariants,
    setVariantAlert,
    variantAlert,
    setNoSkuAlert,
    qtyAlert,
    setQty,
    multiSku,
    setQtyAlert,
    disableButton,
    addToCartHandler,
    noSkuAlert,
    pendingPush,
    isDiscountValid,
    remainingTime,
  } = props;

  // FIND VALID PRICE FOR THE PERIOD OF LIMITED TIME DISCOUNT DURATION
  const validPrice = useCalculateValidPrice(
    skuData?.skus[0] || product,
    isDiscountValid
  );

  // REMOVE SummaryBeforeAddToCart ON CLICK OF AddToCartButton
  // l decided to remove it because when clicked on addToCart, somehow summary shows an unvalid pricing while it s adding the product in card
  const [removeSummary, setRemoveSummary] = useState(false);

  return (
    <div className="col w100p">
      {loadingSkuData ? (
        <LoadingBox></LoadingBox>
      ) : errorSkuData ? (
        <MessageBox>{errorSkuData}</MessageBox>
      ) : (
        ""
      )}
      <div className="row-center w100p marupside1 padupsideh-5 greenbcklight">
        <h1 className="fs15 lh2 beddo-border-bottom">
          {product.freeProductId &&
          product.buyOneGetOneFree &&
          !loadingCampaign &&
          !errorCampaign
            ? `Bir beddo™ ${product.name.split("|")[1]} Alan Herkese Bir ${
                productCampaign.name.split("|")[1]
              } Bedava`
            : product.name}
        </h1>
      </div>
      <div className={width < 600 ? "col w100p" : "offer-container w100p"}>
        <div
          className={
            width < 600 ? "col variant-image w100p" : "col variant-image w32p"
          }
        >
          <ErcModal
            modalTitle={() => (
              <button type="button" className="info-buttons">
                Paket İçeriği
                <i className="fas fa-info-circle green fs1125 marq"></i>
              </button>
            )}
            modalTitleDivWidth={"95%"}
            modalTitleFontSize={"1.25rem"}
            modalTitleLineHeight={"2rem"}
            modalTitleColor={"#0645ad"}
            modalTitleUnderline={""}
            contentTitle={`${product.name} | Paket İçeriği`}
            contentTitleFontSize={"1.35rem"}
            content={[product.boxContent && `* ${product.boxContent}`]}
            modalParagBorderBottom={"0.1rem solid #ff9935"}
            modalParagFontSize={"1.25rem"}
          />

          <ProductLandingGalery skuData={skuData} product={product} />

          <ErcModal
            modalTitle={() => (
              <button type="button" className="info-buttons">
                Teknik Özellikler
                <i className="fas fa-info-circle green fs1125 marq"></i>
              </button>
            )}
            modalTitleDivWidth={"95%"}
            modalTitleFontSize={"1.25rem"}
            modalTitleLineHeight={"2rem"}
            modalTitleColor={"#0645ad"}
            modalTitleUnderline={""}
            contentTitle={`${product.name} | Teknik Özellikler`}
            contentTitleFontSize={"1.35rem"}
            content={[
              product.technicInfo.productSize &&
                `* ${product.technicInfo.productSize}`,
              product.technicInfo.fabricType &&
                `* ${product.technicInfo.fabricType}`,
              product.technicInfo.fabricTouch &&
                `* ${product.technicInfo.fabricTouch}`,
              product.technicInfo.fabricProductionMethod &&
                `* ${product.technicInfo.fabricProductionMethod}`,
              product.technicInfo.fabricWeight &&
                `* ${product.technicInfo.fabricWeight}`,
              product.technicInfo.fillingType &&
                `* ${product.technicInfo.fillingType}`,
              product.technicInfo.fillingProductionMethod &&
                `* ${product.technicInfo.fillingProductionMethod}`,
              product.technicInfo.ingridients &&
                `* ${product.technicInfo.ingridients}`,
              product.technicInfo.material &&
                `* ${product.technicInfo.material}`,
            ]}
            modalParagBorderBottom={"0.1rem solid #ff9935"}
            modalParagFontSize={"1.25rem"}
          />
        </div>
        <div
          className={
            width < 600
              ? "col-jus-webkit w100p lightbck light-green-border rad5r marupside1"
              : "col-jus-webkit w32p lightbck light-green-border rad5r"
          }
          onClick={() => clearCartSkuItems("OrderCartWithVariants")}
        >
          <div className="col w100p marupside1">
            <PriceOffer
              product={product}
              price={price}
              validPrice={validPrice}
              isPending={isPending}
              cartSkuItems={cartSkuItems}
              remainingTime={remainingTime}
              isDiscountValid={isDiscountValid}
            />
          </div>
          <SelectMultiVariant
            singleSku={variants.singleSku}
            fullVariantsArray={variants.fullVariantsArray}
            setChoosenVariants={setChoosenVariants}
            choosenVariants={choosenVariants}
            setVariantAlert={setVariantAlert}
            variantAlert={variantAlert}
            setNoSkuAlert={setNoSkuAlert}
          />
          <SelectQty
            product={product}
            qtyAlert={qtyAlert}
            setQty={setQty}
            cartSkuItems={cartSkuItems}
            sku={multiSku || variants.singleSku}
            price={price}
            validPrice={validPrice}
            isDiscountValid={isDiscountValid}
            setQtyAlert={setQtyAlert}
            isThereApendingOrder={isPending && isPending.isTherePending}
          />

          {!removeSummary && (
            <SummaryBeforeAddToCart
              product={product}
              isDiscountValid={isDiscountValid}
              price={price}
              normalisedQty={qty}
              validPrice={validPrice}
              isThereApendingOrder={isPending && isPending.isTherePending}
              cartSkuItems={cartSkuItems}
            />
          )}

          <div className="w90p marupside1 col">
            <AddCartButton
              setRemoveSummary={setRemoveSummary}
              cartSkuItems={cartSkuItems}
              product={product}
              disableButton={disableButton}
              addToCartHandler={addToCartHandler}
              noSkuAlert={noSkuAlert}
              isThereApendingOrder={isPending && isPending.isTherePending}
              buttonText={
                (variantAlert &&
                  variantAlert.message === "Özellik seçmelisiniz!") ||
                qtyAlert ? (
                  "Şimdi Sipariş Ver"
                ) : pendingPush ? (
                  <>
                    "Şimdi Sipariş Ver" <LoadingBoxWithoutText />
                  </>
                ) : (
                  "Şimdi Sipariş Ver"
                )
              }
            />

            <div className="w100p row-center-webkit beddo-border padupsideq marupsideq">
              <ShippingMessage product={product} />
            </div>
            <div className="w100p beddo-border padupsideq marupsideq">
              <ScarcityMessage product={product} />
            </div>

            <ErcModal
              modalTitle={() => (
                <>
                  <p className="w100p fs1">
                    Nasıl kolayca iade edilir{" "}
                    <i className="far fa-question-circle green fs1125 marq"></i>
                  </p>
                </>
              )}
              modalTitleFontSize={"1.25rem"}
              modalTitleLineHeight={"2rem"}
              modalTitleColor={"#0645ad"}
              modalTitleUnderline={"0.1rem solid #0645ad"}
              contentTitle={`İade Başlatmak Çok Kolay`}
              contentTitleFontSize={"1.35rem"}
              content={[
                `* beddo.com müşteri hizmetleri sayfasına gidin.`,
                `* Sistemde kayıtlı cep telefonu numaranız ile güvenli giriş yapın.`,
                `* Giriş yaptıktan sonra siparişlerim sayfasına gidin ve "Kolay İade Başlat" butonunu tıklayın.`,
                `* Yönergeleri izleyerek saniyeler içinde bir ücretsiz kargo kodu oluşturun.`,
                `* İade paketi oluşturduğunuz kargo kodu ile kargo şubesine teslim edin. `,
                `* Akıllı beddo™ sistemi, iade paketi takip eder ve depomuza ulaşmasını takip eden 24 saat içinde kartınıza iade eder.`,
                `* Kapıda ödeme yaptı iseniz iade başlatırken girdiğiniz IBAN numarasına havale/EFT yapılır.`,
              ]}
              modalParagBorderBottom={"0.1rem solid #ff9935"}
              modalParagFontSize={"1.25rem"}
            />
          </div>
        </div>
        <div
          className={
            width < 600 ? "col variant-image w100p" : "col variant-image w32p"
          }
        >
          <AdvantagesBoard
            product={product}
            productCampaign={productCampaign}
            cartSkuItems={cartSkuItems}
          />
        </div>
      </div>
      <div className="col w90p marupside1"></div>
    </div>
  );
}
